/*
 * @package  diakonie-akademie
 * @author David Hellmann [david@hellmann.io]
 *
 * formBasic
 */

const formBasic = {
  cfg: {
    name: 'form Freeform',
    selectors: {
      form: '.o-form-seminar form',
      abweichendeRechnungsAdresse: '#form-input-abweichendeRechnungsAdresse',
      diakonieMitarbeiter: '#form-input-diakonieMitarbeiter',
      secondAddress: '#secondAddress',
      mitarbeiter: '#mitarbeiter',
      submit: '[name="form_page_submit"]',
    },
    status: {
      validForm: false,
    },
    el: {
      $form: undefined,
      $abweichendeRechnungsAdresse: undefined,
      $diakonieMitarbeiter: undefined,
      $secondAddress: undefined,
      $mitarbeiter: undefined,
    },
  },

  setElements() {
    this.cfg.el.$form = document.querySelector(this.cfg.selectors.form);
    this.cfg.el.$abweichendeRechnungsAdresse = document.querySelector(this.cfg.selectors.abweichendeRechnungsAdresse);
    this.cfg.el.$diakonieMitarbeiter = document.querySelector(this.cfg.selectors.diakonieMitarbeiter);
    this.cfg.el.$secondAddress = document.querySelector(this.cfg.selectors.secondAddress);
    this.cfg.el.$mitarbeiter = document.querySelector(this.cfg.selectors.mitarbeiter);
    this.cfg.el.$submit = document.querySelector(this.cfg.selectors.submit);
  },

  changeRequiredStatus(wrapper, status) {
    [...wrapper.querySelectorAll('input')].forEach(el => {
      el.required = !!status;
    });
  },

  toggleAddress() {
    this.cfg.el.$abweichendeRechnungsAdresse.addEventListener('click', el => {
      if (el.target.checked) {
        el.target.value = 1;
        this.cfg.el.$secondAddress.style.display = 'block';
        this.changeRequiredStatus(this.cfg.el.$secondAddress, true);
      } else {
        el.target.value = 0;
        this.cfg.el.$secondAddress.style.display = 'none';
        this.changeRequiredStatus(this.cfg.el.$secondAddress, false);
      }
    });
  },

  toggleMitarbeiter() {
    this.cfg.el.$diakonieMitarbeiter.addEventListener('click', el => {
      if (el.target.checked) {
        el.target.value = 1;
        this.cfg.el.$mitarbeiter.style.display = 'block';
        this.changeRequiredStatus(this.cfg.el.$mitarbeiter, true);
      } else {
        el.target.value = 0;
        this.cfg.el.$mitarbeiter.style.display = 'none';
        this.changeRequiredStatus(this.cfg.el.$mitarbeiter, false);
      }
    });
  },

  submitForm() {
    if (this.cfg.status.validForm) {
      this.cfg.el.$form.submit();
      this.cfg.el.$submit.disabled = true;
      this.cfg.el.$submit.firstChild.innerHTML = 'Wird gesendet…';
    }
  },

  handleFormSubmit(e) {
    if (this.cfg.el.$form.checkValidity()) {
      e.preventDefault();
      this.cfg.status.validForm = true;
      this.submitForm(e);
    }
  },

  init() {
    this.setElements();

    // Toggle Billing Address
    if (this.cfg.el.$form && this.cfg.el.$secondAddress && this.cfg.el.$abweichendeRechnungsAdresse) {
      this.toggleAddress();
    }

    // Toggle Employee
    if (this.cfg.el.$form && this.cfg.el.$diakonieMitarbeiter && this.cfg.el.$mitarbeiter) {
      this.toggleMitarbeiter();
    }

    // Handle Submit Button
    if (this.cfg.el.$form && this.cfg.el.$submit) {
      this.cfg.el.$submit.addEventListener('click', e => {
        this.handleFormSubmit(e);
      });
    }
  },
};

export default formBasic;
